import { render } from "./HelixHeader.vue?vue&type=template&id=78c8436b"
import script from "./HelixHeader.vue?vue&type=script&lang=js"
export * from "./HelixHeader.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__